import { FC, useCallback } from "react";
import { Stack } from "@mui/material";
import { useDidMount } from "rooks";
import { ProviderType } from "@/services/cloudchipr.api";
import { DropdownSelect } from "@/components/common/select/dropdown-select/DropdownSelect";
import { CsvDownloadDialogTriggerComponent } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/csv-v2/dialog/dimensions/CsvDownloadDialogTriggerComponent";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { ProviderIcon } from "@/components/common/ProviderIcon";
import { useAppSelector } from "@/store/hooks";
import { resourceExplorerGroupingTagKeysDataSelector } from "@/store/common/selectors/resource-explorer/resourceExplorerGroupingTagKeysDataSelector";

interface CsvDownloadDialogTagKeysProps {
  tagKeys: string[];
  onTagKeyChange(data: string[]): void;
}

export const CsvDownloadDialogTagKeys: FC<CsvDownloadDialogTagKeysProps> = ({
  tagKeys,
  onTagKeyChange,
}) => {
  const options = useAppSelector(resourceExplorerGroupingTagKeysDataSelector);

  const dropdownOptions = options?.map(({ value, provider }) => ({
    value,
    label: (
      <Stack direction="row" justifyContent="space-between" pr={1}>
        <TypographyWithTooltip title={value} variant="inherit">
          {value}
        </TypographyWithTooltip>
        <ProviderIcon provider={provider as ProviderType} />
      </Stack>
    ),
  }));

  const tagKeySelectHandler = useCallback(
    (values: string[]) => {
      onTagKeyChange(values);
    },
    [onTagKeyChange],
  );

  useDidMount(() => {
    const initialSelectedItems = options?.map((item) => item.value) ?? [];
    onTagKeyChange(initialSelectedItems);
  });

  return (
    <Stack flex={1}>
      <DropdownSelect
        label="Tags"
        values={tagKeys}
        options={dropdownOptions}
        submitHandlerOnClose={tagKeySelectHandler}
        TriggerComponent={CsvDownloadDialogTriggerComponent}
        listWidth={400}
      />
    </Stack>
  );
};
